/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit'; 
import { getAllOrgsUsers, getAllOrgsUsersByOrgID, getOrgUserHistory } from './orgUsersAction';
  
const initialState = {
    data: {},
    orgUsersList: {},
    orgUserHistory: {}
}
const orgUsersSlice = createSlice({
    name: 'orgUsers',
    initialState,
    extraReducers: {

        [getAllOrgsUsers.fulfilled]: (state, { payload }) => {
            state.orgUsersList =  payload;
        },
        [getOrgUserHistory.fulfilled]: (state, { payload }) => {
            state.orgUserHistory =  payload;
        },
        [getOrgUserHistory.rejected]: (state, { payload }) => {
            state.orgUserHistory =  {};
        },
        [getAllOrgsUsersByOrgID.fulfilled]: (state, { payload }) => {
            state.orgUsersList =  payload;
        },
    }
});

export default orgUsersSlice.reducer